import { render, staticRenderFns } from "./ChartBarNumbersByProduct.vue?vue&type=template&id=16d69186&scoped=true"
import script from "./ChartBarNumbersByProduct.vue?vue&type=script&lang=js"
export * from "./ChartBarNumbersByProduct.vue?vue&type=script&lang=js"
import style0 from "./ChartBarNumbersByProduct.vue?vue&type=style&index=0&id=16d69186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d69186",
  null
  
)

export default component.exports